import React, { useEffect, useState, useCallback } from 'react';

import { IconButton, InputAdornment, makeStyles, MenuItem, TextField } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

import { debounce } from '../../utils/lodashUtils';

const useStyles = makeStyles(() => ({
  icon: {
    '& button': {
      padding: '6px !important',
    },
    '& svg': {
      width: '20px !important',
    },
    display: 'flex',
    justifyItems: 'center',
    paddingRight: '4px',
    width: '25px',
  },
  input: {
    '& input::placeholder': {
      color: '#999999 !important',
      opacity: 1,
    },
    width: '100%',
  },
  item: {},
  itemsList: {
    background: '#FFF',
    border: '1px solid #ddd',
    display: 'none',
    flexDirection: 'column',
    minHeight: '24px',
    minWidth: '400px',
    position: 'absolute',
    top: 52,
    zIndex: 3000,
  },
}));
export default function SearchInput({
  onItemClick,
  items = [],
  onSearch,
  onKeywordUpdate = () => {},
  searchValue = '',
  disableClick = false,
  disableEnter = false,
  placeholder = 'Search',
  style = {},
  inputStyle = {},
  InputProps = {},
  classes: customClasses = {},
}) {
  const classes = useStyles();
  const [keyword, setKeyword] = useState(searchValue);
  const [showUserList, setShowUserList] = useState(false);

  // Create a debounced version of onKeywordUpdate
  const debouncedKeywordUpdate = useCallback(
    debounce((value) => {
      onKeywordUpdate(value);
    }, 500),
    [onKeywordUpdate]
  );

  const onSearchChange = (event) => {
    const { value } = event.target;
    setKeyword(value);
    debouncedKeywordUpdate(value);
  };

  useEffect(() => {
    if (searchValue !== keyword) {
      setKeyword(searchValue);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchValue]);

  const handleSearch = (enter = false) => {
    if (enter && disableEnter) return;
    if (!enter && disableClick) return;

    onSearch(keyword);
  };

  const handleOnFocus = () => {
    setShowUserList(true);
  };

  const handleOnBlur = () => {
    setTimeout(() => setShowUserList(false), 500);
  };

  const handleItemClick = (item) => {
    setShowUserList(false);
    onItemClick(item);
  };

  return (
    <div style={{ position: 'relative', ...style }}>
      <TextField
        className={classes.input}
        style={inputStyle}
        onChange={onSearchChange}
        placeholder={placeholder}
        onFocus={handleOnFocus}
        onBlur={handleOnBlur}
        onKeyUp={(evt) => {
          if (evt.key === 'Enter') {
            handleSearch(true);
          }

          if (evt.key === 'Escape') {
            setShowUserList(false);
          }
        }}
        value={keyword}
        InputProps={{
          startAdornment: (
            <InputAdornment className={classes.icon}>
              <IconButton onClick={handleSearch}>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ),
          ...InputProps,
        }}
        classes={customClasses}
        type="text"
      />
      <div className={classes.itemsList} style={{ display: showUserList && items.length ? 'flex' : 'none' }}>
        {items?.map((option) => (
          <MenuItem className={classes.item} key={option.key} onClick={() => handleItemClick(option.value)}>
            {option.label}
          </MenuItem>
        ))}
      </div>
    </div>
  );
}
